/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { browserCheck } from '@ta-interaktiv/browsercheck'

const isMobile = browserCheck.isMobile

export function AppComponent() {
  return (
    <div className='index'>
      <ThemeSwitch />

      <div className='wrapper'>
        <h3>
          2023 erhitzen sich die Weltmeere viel stärker als in den Vorjahren
        </h3>
        <div className='description'>
          Abweichung der Meeresoberflächentemperatur vom langjährigen Mittel
          (1985–1990)
        </div>
        <div>
          <h4>Kalenderwoche 23</h4>
          <img
            className='ui fluid image'
            src={require('../../images/kw-23.jpg')}
          />
          <div className='source'>Quelle: NOAA</div>
        </div>
      </div>
    </div>
  )
}
